import { useMutation } from '@tanstack/react-query';
import { post } from '@truefit/http-utils';

export type McpConsentDecision = { approve: true; orgId: number } | { approve: false };

/** Approves or denies the request; either way the answer is where to send the browser next. */
export const useMcpConsentDecisionMutation = (requestId: string) =>
  useMutation({
    mutationFn: async (decision: McpConsentDecision) => {
      const { data } = decision.approve
        ? await post<{ redirectUrl: string }>(`/v1.0/oauth/requests/${requestId}/approve`, {
            orgId: decision.orgId,
          })
        : await post<{ redirectUrl: string }>(`/v1.0/oauth/requests/${requestId}/deny`, {});
      return data.redirectUrl;
    },
  });

export default useMcpConsentDecisionMutation;
